"use client";
import { FirstLoginForm } from "./first-login-form"

export default function FirstLoginPage() {
    return (
        <div className="min-h-screen w-full relative overflow-hidden bg-gradient-to-br from-gray-200 via-gray-400 to-gray-500">
            <div className="relative flex min-h-screen items-center justify-center p-4">
                <FirstLoginForm />
            </div>
        </div>
    );
}